import {useMutation} from "@tanstack/react-query";
import {obsoleteCustomerOfferMutationOptions} from "./obsolete-customer-offer.mutation-options";

export function useObsoleteCustomerOffer() {
  return useMutation(obsoleteCustomerOfferMutationOptions());
}
